/* Productvideo (MP4): laadt + speelt pas wanneer in beeld, pauzeert eruit.
   Houdt de laadtijd laag — de video wordt niet opgehaald bij het laden van de pagina. */
(function () {
  if (window.__pdpVideoInit) return;
  window.__pdpVideoInit = true;

  function start(v) {
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    if (v.dataset.autoplay === 'true') {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function setup() {
    var vids = document.querySelectorAll('video.product-info-video[data-src]');
    if (!vids.length) return;

    if (!('IntersectionObserver' in window)) {
      vids.forEach(start);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          start(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });

    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();
